import React from 'react'

import Button from 'components/button'

import { ButtonContainer, ConferenceButtonWrapper, ConferenceConditions } from '../styled'

const SearchButton = ({
  labelDefault,
  labelEvents,
  isResearch,
  isConference,
  isResearchBoxExpanded,
  handleOnSubmit,
  openTermsModalHandler,
  shouldShowTermsLink,
  disableBtn
}) => {
  const researchProps = {
    padding: '16px 10px',
    fontSize: 14
  }

  const searchProps = {
    large: true,
    fontSize: 16
  }

  const buttonProps = isResearch ? researchProps : searchProps

  const ButtonJSX = (
    <ButtonContainer
      isResearch={isResearch}
      flex={isConference && (shouldShowTermsLink ? 0.7 : 1)}
      isConference={isConference}
    >
      <Button
        disabled={disableBtn}
        disableIndex={!isResearchBoxExpanded && isResearch}
        name="search-flights"
        id="search-flights"
        onClick={handleOnSubmit}
        uppercase
        {...buttonProps}
      >
        {labelDefault}
      </Button>
    </ButtonContainer>
  )

  // Could be conference searchBox but terms could be empty or had failed fetching.
  return isConference ? (
    <ConferenceButtonWrapper>
      {shouldShowTermsLink && (
        <ConferenceConditions href="#" onClick={openTermsModalHandler}>
          {labelEvents}
        </ConferenceConditions>
      )}
      {ButtonJSX}
    </ConferenceButtonWrapper>
  ) : (
    ButtonJSX
  )
}

export default SearchButton
